import React, { ComponentProps } from 'react';
import { Button as MUIButton } from '@mui/material';

function Button({
  children,
  variant = 'contained',
  color = 'primary',
  ...props
}: {
  children?: React.ReactNode;
} & ComponentProps<typeof MUIButton>) {
  return (
    <MUIButton variant={variant} color={color} {...props}>
      {children}
    </MUIButton>
  );
}

export default Button;
